import React, { useMemo, useCallback } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IProps {
	onChange: (value: string) => void;
	setId: string;
}

export const RecipientInn: React.FC<IProps> = React.memo(({ onChange, setId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterRecipientInn') },
			{
				validator(_, value) {
					if (!value || value.length === 10 || value.length === 12) {
						return Promise.resolve();
					}
					return Promise.reject(new Error(t('enterRecipientInnShouldContainCertainNumberOfDigits')));
				},
			},
		],
		[t],
	);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '').slice(0, 12);
			onChange(onlyDigits);
			return onlyDigits;
		},
		[onChange],
	);

	return (
		<FormInput
			testId="RecipientInn"
			name={`recipientInn-${setId}`}
			label="recipientInnLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
});
